<script>
    import Button, {Group, GroupItem, Label, Icon} from '@smui/button';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    function save() {
        dispatch('save');
    }
</script>
<div class="trailing-button">
    <div><Button variant="raised" on:click={save}><Label>Opslaan</Label></Button></div>
</div>
